"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Canvas = function (_a) {
    var width = _a.width, height = _a.height, children = _a.children;
    var canvasRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(false), isPainting = _b[0], setIsPainting = _b[1];
    var _c = (0, react_1.useState)(undefined), mousePosition = _c[0], setMousePosition = _c[1];
    var startPaint = (0, react_1.useCallback)(function (event) {
        console.log("click canvas");
        var coordinates = getCoordinates(event);
        if (coordinates) {
            setMousePosition(coordinates);
            setIsPainting(true);
        }
    }, []);
    (0, react_1.useEffect)(function () {
        if (!canvasRef.current) {
            return;
        }
        var canvas = canvasRef.current;
        canvas.addEventListener('mousedown', startPaint);
        return function () {
            canvas.removeEventListener('mousedown', startPaint);
        };
    }, [startPaint]);
    var paint = (0, react_1.useCallback)(function (event) {
        if (isPainting) {
            var newMousePosition = getCoordinates(event);
            if (mousePosition && newMousePosition) {
                drawLine(mousePosition, newMousePosition);
                setMousePosition(newMousePosition);
            }
        }
    }, [isPainting, mousePosition]);
    (0, react_1.useEffect)(function () {
        if (!canvasRef.current) {
            return;
        }
        var canvas = canvasRef.current;
        canvas.addEventListener('mousemove', paint);
        return function () {
            canvas.removeEventListener('mousemove', paint);
        };
    }, [paint]);
    var exitPaint = (0, react_1.useCallback)(function () {
        setIsPainting(false);
        setMousePosition(undefined);
    }, []);
    (0, react_1.useEffect)(function () {
        if (!canvasRef.current) {
            return;
        }
        var canvas = canvasRef.current;
        canvas.addEventListener('mouseup', exitPaint);
        canvas.addEventListener('mouseleave', exitPaint);
        return function () {
            canvas.removeEventListener('mouseup', exitPaint);
            canvas.removeEventListener('mouseleave', exitPaint);
        };
    }, [exitPaint]);
    var getCoordinates = function (event) {
        if (!canvasRef.current) {
            return;
        }
        var canvas = canvasRef.current;
        var rect = canvas.getBoundingClientRect();
        return { x: event.clientX - rect.left, y: event.clientY - rect.top };
    };
    var drawLine = function (originalMousePosition, newMousePosition) {
        if (!canvasRef.current) {
            return;
        }
        var canvas = canvasRef.current;
        var context = canvas.getContext('2d');
        if (context) {
            context.strokeStyle = 'red';
            context.lineJoin = 'round';
            context.lineWidth = 5;
            context.beginPath();
            context.moveTo(originalMousePosition.x, originalMousePosition.y);
            context.lineTo(newMousePosition.x, newMousePosition.y);
            context.closePath();
            context.stroke();
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("canvas", { ref: canvasRef, height: height, width: width, style: { position: 'absolute' } }),
        children));
};
Canvas.defaultProps = {
    width: window.innerWidth,
    height: window.innerHeight,
};
exports.default = Canvas;
